export default __webpack_public_path__ + "static/media/Q3-No.94aaab00.png";